import { css } from "@linaria/core";
import {
  combineTokens,
  units,
  colors,
  outline,
  surfaces,
  easings,
} from "@pm2/compat";

export const tokens = combineTokens("--progress-bar", {
  filled: "0",
  dragHandleOffset: "0",
});

export const wrapper = css`
  position: relative;
  z-index: 1;

  height: 100%;
  width: 100%;
  min-height: inherit;

  border-radius: ${units.px(2)};

  cursor: pointer;

  &[data-disabled="true"] {
    pointer-events: none;
  }

  &::before,
  &::after {
    content: "";

    position: absolute;
    top: 50%;
    left: 0;
    right: 0;

    height: ${units.px(5)};

    border-radius: inherit;
  }

  &::before {
    background: ${colors.gray.alpha10()};
    transform: translateY(-50%);
  }

  &::after {
    width: calc(${tokens.filled()} * 100%);

    background: ${colors.black()};

    transform: translateY(-50%);
    transform-origin: left center;
  }
`;

export const track = css`
  position: relative;

  margin-inline: ${units.px(9)};

  height: 100%;
  min-height: inherit;
`;

export const dragHandle = css`
  ${outline({
    borderRadius: "50%",
    target: "& > span[data-outline]",
    offset: units.px(3),
  })};

  position: absolute;
  top: 50%;
  left: calc(${tokens.dragHandleOffset()} * 100%);
  z-index: 3;

  height: ${units.px(20)};
  width: ${units.px(20)};

  background-color: ${surfaces.gray.sim100()};
  border-radius: 50%;

  cursor: grab;

  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
  transition: transform 0.125s ${easings.outQuad}, opacity 0.1s linear;

  touch-action: none;

  && > span[data-outline] {
    position: static;
  }

  & > span[data-thumb],
  &::before,
  &::after {
    position: absolute;
    top: 50%;

    height: ${units.px(9)};
    width: ${units.px(1.5)};

    background-color: ${surfaces.gray.sim100({
      property: "color",
      alpha: 0.5,
    })};

    transform: translate(-50%, -50%);
    transition: background-color 0.1s linear;
  }

  &::before {
    content: "";
    left: calc(50% - ${units.px(4)});
  }

  &::after {
    content: "";
    left: calc(50% + ${units.px(4)});
  }

  & > span[data-thumb] {
    content: "";
    left: 50%;
  }

  .${wrapper}[data-is-dragging="true"] &,
  .${wrapper}:hover &,
  &&:focus-visible {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:hover,
  &:active,
  .${wrapper}[data-is-dragging="true"] & {
    &::before,
    &::after,
    & > span[data-thumb] {
      background-color: ${surfaces.gray.sim100({ property: "color" })};
    }
  }

  &&:hover {
    transform: translate(-50%, -50%) scale(1.15);
  }

  &&:active,
  .${wrapper}[data-is-dragging="true"] & {
    cursor: grabbing;
    transform: translate(-50%, -50%) scale(0.95);
  }
`;
